import { Fragment, useEffect, useState } from "react";
import BarraLateralComponent from '../components/BarraLateralComponent';
import { Icon } from '@iconify/react';
import styleBtn from '../styles/btn.module.scss';
import PictureComponent from "../components/PictureComponent";
import TitleH4Component from "../components/TitleH4Component";
import { useAuth } from "../context/AuthContext";
import { useLocation, useNavigate } from 'react-router-dom';
import { RUTA_LOGIN } from "../constants/rutas";
const RouterPrivate = ({ allowedRoles = [], component }) => {
    const { isAuthenticated, isAdmin, loading, checkAuth, isSuper } = useAuth();
    const [controlMenu, setControlMenu] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Menú lateral (solo tablet/desktop; en móvil sigue funcionando el menú
    // deslizable de arriba, controlado por controlMenu, sin relación con
    // esto). Por defecto queda colapsado a un riel de íconos y se expande
    // solo al pasar el cursor (ver global.scss); "fijado" lo deja siempre
    // expandido sin depender del hover. Se guarda en localStorage para que
    // se recuerde la preferencia entre sesiones.
    const [menuFijado, setMenuFijado] = useState(() => {
        const guardado = localStorage.getItem('menuFijado');
        return guardado === 'true';
    });

    useEffect(() => {
        localStorage.setItem('menuFijado', menuFijado);
    }, [menuFijado]);

    const toggleFijarMenu = () => {
        setMenuFijado((fijado) => !fijado);
    };

    // Verifica autenticación al cambiar de ruta
    useEffect(() => {
        checkAuth();
    }, [location.pathname]);

    //Controla acceso según rol
    useEffect(() => {
        if (!loading && isAuthenticated) {
            
            let userRole = "vendedor"; // default

            if (isSuper) {
                userRole = "super";
            } else if (isAdmin) {
                userRole = "admin";
            }

            if (!allowedRoles.includes(userRole)) {
                navigate("/home");
            }

        } else if (!loading && !isAuthenticated) {
            navigate(RUTA_LOGIN);
        }
    }, [isAuthenticated, isAdmin, loading, allowedRoles, navigate]);

    // Espera a saber si el usuario está autenticado
    if (loading) return null;
    if (!isAuthenticated) return null;


    const abrirMenu = () => {
        setControlMenu(!controlMenu);
    }


    return (
        <Fragment>
            <div className={`content-app ${menuFijado ? 'menuFijado' : ''}`}>
                {controlMenu ? <div className={'containerModal'}></div> : null}
                <div className=" header-movil">
                    <button type="button" onClick={abrirMenu} className={`${styleBtn.btn_desnudo} ${styleBtn.icon}`}><Icon icon="ic:baseline-menu" /></button>
                    <div className={`d-flex align-items-center`}>
                        <TitleH4Component styleGroup="box-text color-dark fw700 roboto me-2 mb-0">Maderas el paca</TitleH4Component>
                        <PictureComponent src="/img/logo.png" alt="logo" styleGroup={`w-auto imgLogo`} />
                    </div>
                </div>

                <div className={`menu ${controlMenu ? 'active' : ''}`}>
                    <div className="barra-lateral">
                        <BarraLateralComponent
                            setControlMenu={setControlMenu}
                            menuFijado={menuFijado}
                            onToggleFijar={toggleFijarMenu}
                        />
                    </div>
                </div>
                <div className='content mt-3 '>
                    {component}
                </div>
            </div>
        </Fragment>
    )
}

export default RouterPrivate;